import script from "./ForestGallery.vue?vue&type=script&setup=true&lang=ts"
export * from "./ForestGallery.vue?vue&type=script&setup=true&lang=ts"

import "./ForestGallery.vue?vue&type=style&index=0&id=0fe9fbfa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fe9fbfa"]])

export default __exports__